module.exports = __webpack_public_path__ + "img/svg/background-ranked-classification.9171271c26b88f7cee27d3b1edee088f.svg";